import Axios from "axios";
import {
  GET_DOCUMENT_TYPE,
  POST_DOCUMENT_TYPE,
  UPDATE_DOCUMENT_TYPE,
  DELETE_DOCUMENT_TYPE,
  CLEAR_ERRORS,
  GET_ERRORS,
  LOADING_DOCUMENT_TYPE,
} from "./types";

const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

const success = () => {
  if (!document.getElementById("document-s")) return;
  document.getElementById("document-s").style.display = "block";
  setTimeout(
    () => (document.getElementById("document-s").style.display = "none"),
    5000
  );
  document.querySelector("#closeDocumentType").click();
};
const error = () => {
  if (!document.getElementById("document-e")) return;
  document.getElementById("document-e").style.display = "block";
  setTimeout(
    () => (document.getElementById("document-e").style.display = "none"),
    5000
  );
};

export const postDocumentType = (dataBody) => (dispatch) => {
  return Axios.post("/api/v1/document_types", dataBody)
    .then((res) => {
      dispatch({
        type: POST_DOCUMENT_TYPE,
        payload: res.data,
      });
      dispatch(clearErrors());
      success();
      return { success: true };
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
      error();
      return { success: false };
    });
};

export const getDocumentType = (store_id) => (dispatch) => {
  dispatch(setUserLoading());
  Axios.get(
    `/api/v1/document_types${store_id ? `?order_shop_id=${store_id}` : ""}`
  )
    .then((res) => {
      dispatch({
        type: GET_DOCUMENT_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getDocumentTypeOption = () => (dispatch) => {
  return Axios.get("/api/v1/document_types")
    .then((res) => {
      return res;
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const updateDocumentType = (id, body) => (dispatch) => {
  return Axios.put(`/api/v1/document_types/${id}`, body)
    .then((res) => {
      dispatch({
        type: UPDATE_DOCUMENT_TYPE,
        payload: res.data,
      });
      dispatch(clearErrors());
      success();
      return { success: true };
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
      error();
      return { success: false };
    });
};

export const deleteDocumentType = (id) => (dispatch) => {
  Axios.delete(`/api/v1/document_types/${id}`)
    .then((res) => {
      dispatch({
        type: DELETE_DOCUMENT_TYPE,
        payload: id,
      });
      dispatch(clearErrors());
      success();
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
      error();
    });
};

export const setUserLoading = () => {
  return {
    type: LOADING_DOCUMENT_TYPE,
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
